$(function () {
  var currentPage;
  // 初始化   默认匹配hash值,  如果没有展示第一项
  const hash = location.hash.split("#")[1] || 1;
  $(".about-content-nav li .content-nav-icon").removeClass(
    "content-nav-icon-active"
  );
  $(".about-content-nav li .content-nav-line").removeClass("line-hover");
  $(".about-content-nav li")
    .eq(hash - 1)
    .find(".content-nav-icon")
    .addClass("content-nav-icon-line");
  $(".about-content-nav li")
    .eq(hash - 1)
    .find(".content-nav-line")
    .addClass("line-hover");
  $($(".about-main")[hash - 1]).show();
  // 最新动态下的tab默认展示第一项
  $(".app-about-part4-wrap .updating-block").eq(0).addClass("show");
  // 默认 截取当前页的前10条数据
  $(".app-about-part4-wrap .updating-block")
    .children(`a:lt(10)`)
    .addClass("show");
  if ($(".app-about-part4-wrap .updating-block").eq(0).data("total") > 0) {
    setTimeout(function () {
      $(".pagination").pagination(
        {
          totalData: $(".updating-block").eq(0).data("total"),
          coping: true,
          showData: 10,
          homePage: "首页",
          endPage: "末页",
          prevContent: "上页",
          nextContent: "下页",
          keepShowPN: true,
          current: currentPage,
          mode: "unfixed", //分页模式，unfixed：不固定页码数量，fixed：固定页码数量
          count: 1, //mode为unfixed时显示当前选中页前后页数，mode为fixed显示页码总数
          callback: function (e) {
            currentPage = e.getCurrent();
            $(".updating-block").eq(0).children("a").removeClass("show");
            // 切换的时候先截取currentpage的10条数据
            $(".updating-block")
              .eq(0)
              .children(`a:lt(${currentPage * 10})`)
              .addClass("show");
            // 然后过滤掉小于currentpage-1的数据
            $(".updating-block")
              .eq(0)
              .children(`a:lt(${(currentPage - 1) * 10})`)
              .removeClass("show");
            // 然后过滤掉大于currentPage*10的数据
            $(".updating-block")
              .eq(0)
              .children(`a:gt(${currentPage * 10})`)
              .removeClass("show");
          },
        },
        function (e) {}
      );
    }, 100);
  }

  // 人事招聘默认展示第一个职位
  $(".list-item-wrap .list-item .list").eq(0).addClass("active");
  $(".list-item-wrap .list-item .list").eq(0).addClass("first");
  $(".list-content-wrap .list-block4").eq(0).addClass("block");

  /********菜单导航栏切换***********/
  $(".about-content-nav").on("click", "li", function () {
    $(".about-content-nav li .content-nav-line").removeClass("line-hover");
    $(".about-content-nav li .content-nav-icon").removeClass(
      "content-nav-icon-line"
    );
    $(this).children(".content-nav-line").addClass("line-hover");
    $(this).children(".content-nav-icon").addClass("content-nav-icon-line");
    $(".about-main").hide();
    var num = $(".about-content-nav li").index(this) + 1;
    location.hash = num; //切换保存hash值
    // var scrollHeight;
    // scrollHeight = 400;
    // $("html,body").animate({ scrollTop: scrollHeight }, 400);
    $($(".about-main")[num - 1]).show();
  });

  /********最新动态tab***********/
  $(".updating-dec").on("click", "li", function () {
    // 切换tab之后重新设置currentPage是第一页
    currentPage = 1;
    var index = $(".updating-dec li").index(this);
    $(".updating-dec li").removeClass("active");
    $(".updating-dec li").eq(index).addClass("active");
    $(".updating-block").removeClass("show");
    $(".updating-block").eq(index).addClass("show");

    // 默认 截取当前页的前10条数据
    $(".updating-block").eq(index).children(`a:lt(10)`).addClass("show");
    setTimeout(function () {
      $(".pagination").pagination(
        {
          totalData: $(".updating-block").eq(index).data("total") || 0,
          coping: true,
          showData: 10,
          homePage: "首页",
          endPage: "末页",
          prevContent: "上页",
          nextContent: "下页",
          keepShowPN: true,
          current: currentPage,
          mode: "unfixed", //分页模式，unfixed：不固定页码数量，fixed：固定页码数量
          count: 1, //mode为unfixed时显示当前选中页前后页数，mode为fixed显示页码总数
          callback: function (e) {
            currentPage = e.getCurrent();
            $(".updating-block").eq(index).children("a").removeClass("show");
            // 切换的时候先截取currentpage的10条数据
            $(".updating-block")
              .eq(index)
              .children(`a:lt(${currentPage * 10})`)
              .addClass("show");
            // 然后过滤掉小于currentpage-1的数据
            $(".updating-block")
              .eq(index)
              .children(`a:lt(${(currentPage - 1) * 10})`)
              .removeClass("show");
            // 然后过滤掉大于currentPage*10的数据
            $(".updating-block")
              .eq(index)
              .children(`a:gt(${currentPage * 10})`)
              .removeClass("show");
          },
        },
        function (e) {}
      );
    }, 100);
  });

  /********了解超级码  产品简介***********/
  $(".product-dec-div").on("click", ".product-dec-list", function () {
    var index = $(".product-dec-div .product-dec-list").index(this);
    $(".product-dec-div .product-dec-list").removeClass("active");
    $(".about-part1-product-text").removeClass("block");
    $(".product-dec-list img").attr(
      "src",
      "/images/about/index_icon/profile-icon1.png"
    );
    $($(".about-part1-product-text")[index]).addClass("block");
    $($(".product-dec-div .product-dec-list")[index]).addClass("active");
    $($(".product-dec-list img")[index]).attr(
      "src",
      "/images/about/index_icon/profile-icon0-hover.png"
    );
  });

  // 了解超级码  -------------   团队优势

  $(".about-part1-group-text").first().addClass("block");
  $(".item-dec .item-li").first().addClass("active");
  $(".item-dec").on("click", "li", function () {
    var index = $(".item-dec li").index(this);
    $(".item-dec .item-li").removeClass("active");
    $(".about-part1-group-text").removeClass("block");
    $($(".about-part1-group-text")[index]).addClass("block");
    $($(".item-dec .item-li")[index]).addClass("active");
  });

  /*********************人事招聘**************/
  $(".list-item").on("click", "li", function () {
    var index = $(".list-item li").index(this);
    $(".list-block4").removeClass("block");
    $(".list-block4").eq(index).addClass("block");
    $(".list-item li").removeClass("active");
    $(".list-item li").eq(index).addClass("active");
  });

  // 文章内容展开还是收起
  let html = $(".about-item2 .item-detail-content1").html();
  let text = $(".about-item2 .item-detail-content1").text();
  $(".about-item2 .item-detail-content1").html(
    $(".about-item2 .item-detail-content1").text()
  );
  $(".about-item4 .item-detailCont").html(
    $(".about-item4 .item-detailCont").text()
  );
  $(".about-limitTri").on("click", ".triBottom", function () {
    // $(".about-item2 .item-detail-content").css("display", "block",'');
    $(".about-item2 .item-detail-content1").removeClass("hideCont");
    $(this).css("display", "none");
    $(".about-item2 .triTop").css("display", "block");
    $(".about-item2 .item-detail-content1").html(html);
  });
  $(".about-limitTri").on("click", ".triTop", function () {
    // $(".about-item2 .item-detail-content").css("display", "-webkit-box");
    $(".about-item2 .item-detail-content1").addClass("hideCont");
    $(this).css("display", "none");
    $(".about-item2 .triBottom").css("display", "block");
    $(".about-item2 .item-detail-content1").html(text);
  });

  $(".about-limitTri2").on("click", ".triBottom", function () {
    // $(".about-item4 .item-detailCont").css("display", "block");
    $(".about-item4 .item-detailCont").removeClass("hideCont2");
    $(this).css("display", "none");
    $(".about-item4 .triTop").css("display", "block");
    $(".about-item4 .item-detailCont").html(html);
  });
  $(".about-limitTri2").on("click", ".triTop", function () {
    // $(".about-item4 .item-detailCont").css("display", "-webkit-box");
    $(".about-item4 .item-detailCont").addClass("hideCont2");
    $(this).css("display", "none");
    $(".about-item4 .triBottom").css("display", "block");
    $(".about-item4 .item-detailCont").html(text);
  });

  /********人事招聘职位切换mobile***********/
  $(".list-item-mobile").on("click", ".list", function () {
    var index = $(".list-item-mobile .list").index(this);
    $(".list-item-mobile .list").removeClass("active");
    $(".part7-block-item-mobile").removeClass("block");
    $(".list-item-mobile .list-icon").show();
    $(".list-item-mobile .list-icon-active").removeClass("show");
    if ($(".list-item-mobile .list").eq(index).attr("data-checked") == "true") {
      $(".list-item-mobile .list").attr("data-checked", "false");
      $($(".list-item-mobile .list")[index]).removeClass("active");
      $($(".list-item-mobile .list-icon-active")[index]).removeClass("show");
      $($(".list-item-mobile .list-icon")[index]).show();
      $($(".item-info-content1-mobile")[index]).html(
        // htmlDecode(
        //   htmlDecode($($(".join-mobile-box-description")[index]).html())
        // )
        $($(".join-mobile-box-description")[index]).html()
      );
      $($(".item-info-content2-mobile")[index]).html(
        // htmlDecode(
        //   htmlDecode($($(".join-mobile-box-jobRequirement")[index]).html())
        // )
        $($(".join-mobile-box-jobRequirement")[index]).html()
      );
      $($(".part7-block-item-mobile")[index]).removeClass("block");
      $(".list-item-mobile .list").eq(index).attr("data-checked", "false");
    } else {
      $(".list-item-mobile .list").attr("data-checked", "false");
      $($(".list-item-mobile .list")[index]).addClass("active");
      $($(".list-item-mobile .list-icon-active")[index]).addClass("show");
      $($(".list-item-mobile .list-icon")[index]).hide();
      $($(".item-info-content1-mobile")[index]).html(
        // htmlDecode(
        //   htmlDecode($($(".join-mobile-box-description")[index]).html())
        // )
        $($(".join-mobile-box-description")[index]).html()
      );
      $($(".item-info-content2-mobile")[index]).html(
        // htmlDecode(
        //   htmlDecode($($(".join-mobile-box-jobRequirement")[index]).html())
        // )
        $($(".join-mobile-box-jobRequirement")[index]).html()
      );
      $($(".part7-block-item-mobile")[index]).addClass("block");
      $(".list-item-mobile .list").eq(index).attr("data-checked", "true");
    }
  });
});
